import React, { useState, useEffect } from "react";
import { apiRequest } from "../apiService/allApi";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const fetchOrders = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await apiRequest(
        `api/order?page=${page}&limit=${limit}`,
        "GET",
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (response?.data?.orders) {
        setOrders(response.data.orders);
      }
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchOrders();
  }, [page, limit]);

  return (
    <div className="my-orders">
      <h4 className="title mb-3">My Orders</h4>
<div className="order-grid">
      {loading && <p>Loading...</p>}

      {!loading && orders.length === 0 && <p>No orders found</p>}
      {orders.map((order) => (
        <div key={order._id} className="order-card">
          <div className="order-header">
            <h4>Order #{order.invoice}</h4>
            <span className={`status ${order.status.toLowerCase()}`}>
              {order.status}
            </span>
          </div>

          {/* Products */}
          {order.cart?.map((item, index) => (
            <div key={index} className="product-row">
              <img
                src={item.prices?.image}
                alt={item.prices?.name}
                className="product-image"
              />

              <div>
                <p>
                  <strong>Product:</strong> {item.prices?.name}
                </p>
                <p>
                  <strong>Price:</strong> ₹{item.prices?.price}
                </p>
                <p>
                  <strong>Quantity:</strong> {item.prices?.qty}
                </p>
              </div>
            </div>
          ))}

          <div className="order-details">
            <p>
              <strong>Date & Time:</strong>{" "}
              {new Date(order.createdAt).toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}
            </p>

            <p>
              <strong>Total:</strong> ₹{order.total}
            </p>
          </div>
        </div>
      ))}

</div>

      {/* ===== Pagination Controls ===== */}
      <div className="pagination-controls mt-4">
        {/* Limit Buttons */}
        <div className="limit-buttons">
          {/* <span>Show:</span>
          {[1, 5, 15].map((l) => (
            <button
              key={l}
              className={limit === l ? "active" : ""}
              onClick={() => {
                setLimit(l);
                setPage(1); // limit change par page reset
              }}
            >
              {l}
            </button>
          ))} */}
        </div>

        {/* Prev / Next Buttons */}
        <div className="page-buttons">
          <button
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </button>

          <span className="page-number">Page {page}</span>

          <button
            disabled={orders.length < limit}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyOrders;
